import React from "react";
import styles from "./resume.module.less";
import wordIMG  from '../../../images/word.png';
import { NavLink } from "react-router-dom";
function ResumePage()
{
    return (
        <div id={styles.resume}>
           <a href="/files/cv-en.docx" className={styles.resumeItem}>
                <img src={wordIMG} alt="" />
                <p>
                    Resume in English
                </p>
            </a>
            <a href="/files/cv-en.docx" className={styles.resumeItem}>
                <img src={wordIMG} alt="" />
                <p>
                Резюме на Русском
                </p>
            </a>
        </div>
    );
}

export default ResumePage;